'use client';

import { useNavigation } from '@actr/hooks/src/navigation/hook';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { Link } from '@actr/ui/src/components/link';
import React, { FC } from 'react';

export type BreadcrumbProps = {
  crumb: {
    path: string;
    title: string;
  }[];
  dynamic?: boolean;
}

const Breadcrumb: FC<BreadcrumbProps> = ({ crumb, dynamic = true }) => {
  const { navigate } = useNavigation();
  const links = [];

  if (dynamic) {
    links.push({
      path: '/',
      title: 'Главная'
    });
  }

  links.push(...crumb);

  return (
    <div itemScope itemType="https://schema.org/BreadcrumbList">
      {
        links.map((link, index) => {
          const isLast = index === links.length - 1;

          if (isLast) {
            return (
              <span itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" key={index}>
                <a style={{ pointerEvents: 'none', textDecoration: 'none' }} itemProp="item" href={`${link.path}`}>
                  <Text font="paragraph.s.semi">
                    <span itemProp="name">{ link.title }</span>
                  </Text>
                </a>
                <meta itemProp="position" content={(index + 1).toString()} />
              </span>
            );
          }
          return (
            <span itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem" key={index}>
              <Link
                itemProp="item"
                font="paragraph.s.semi"
                href={`${link.path}`}
                onClick={() => navigate(link.path, { useRouter: false })}>
                <span itemProp="name">{ link.title }</span>
              </Link>
              <Text font="paragraph.s.semi">
                {' / '}
              </Text>
              <meta itemProp="position" content={(index + 1).toString()} />
            </span>
          );
        })
      }
    </div>
  );
};
export default Breadcrumb;
